import React from "react";

const SwrContext = React.createContext({});
const TourContext = React.createContext({});

export { SwrContext, TourContext };
